export type Colors = {
    textCancel: string;
    bbTech: string;
    colorWarn: string;
    buttonCancel20: string;
    bbTechDisabled: string;
    DefaultTextColor: string;
};

export type Typography = {
    big: string;   // 큰 폰트 크기
    normal: string; // 기본 폰트 크기
    small: string;  // 작은 폰트 크기
    fontFamily: string; // 폰트 패밀리
};

export interface Theme {
    colors: Colors;
    typography: Typography;
}

const theme: Theme = {
    colors: {
        textCancel: '#6C757D', 
        bbTech: '#14B446',
        colorWarn: '#c03221',
        buttonCancel20: '#6c757d33',
        bbTechDisabled: '#14B44666',
        DefaultTextColor: '#232D42',
    },
    typography: {
        big: '24px',   // 큰 텍스트 크기
        normal: '18px', // 기본 텍스트 크기
        small: '14px',  // 작은 텍스트 크기
        fontFamily: "'Noto Sans', sans-serif",
    },
};

export default theme;